import { Controller, Scene } from 'scrollmagic';
import 'nodelist-foreach-polyfill';

document.addEventListener('DOMContentLoaded', () => {
  const controller = new Controller();
  document.querySelectorAll('[data-scroll-animation]').forEach((el) => {
    const scene = new Scene({
      triggerElement: el,
      triggerHook: 'onEnter',
      offset: Math.min(0.5 * el.clientHeight, 200),
      reverse: false,
    });
    scene.addTo(controller);
    scene.on('enter', () => {
      el.classList.add('rendered');
    });
  });
});
